











































import Vue from 'vue';
import SecondGraduationInstitutionInfoForm, {
  InstitutionOption,
  SecondGraduationInstitutionInfoFormEvent,
} from '@/components/forms/SecondGraduationInstitutionInfoForm.vue';
import PipelineMenuWrapper from '@/components/PipelineMenuWrapper.vue';
import BackButton from '@/components/BackButton.vue';
import BottomButton from '@/components/BottomButton.vue';
import pipeline from '@/pipeline';
import { EvaluationSecondGraduation, Institution } from '@/store/modules/admission/state';
import i18n from '@/i18n';
import { Toast, Loading } from '@descomplica/vue-components';
import { AnalyticsActions } from '@/store/modules/analytics/actions';

export default Vue.extend({
  components: {
    SecondGraduationInstitutionInfoForm,
    PipelineMenuWrapper,
    BackButton,
    BottomButton,
    Toast,
    Loading,
  },
  data() {
    return {
      form: {
        course: this.$store.getters.secondGraduation?.courseName || '',
        graduationYear: this.$store.getters.secondGraduation?.year || '',
        institution: undefined,
      } as SecondGraduationInstitutionInfoFormEvent,
      hasAcceptedToS: this.$store.getters.secondGraduation?.hasAcceptedToS,
      availableInstitutions: [] as InstitutionOption[],
      searchTimeout: null as any,
      isSearching: false,
      error: false,
      loading: false,
    };
  },
  computed: {
    isContinueEnabled(): boolean {
      const { course, graduationYear, hasErrors } = this.form;
      return (
        !hasErrors &&
        !!course &&
        !!graduationYear &&
        !!this.currentInstitution.value &&
        this.hasAcceptedToS
      );
    },
    currentInstitution(): InstitutionOption {
      const { secondGraduation } = this.$store.getters;

      const institution: InstitutionOption = secondGraduation?.institution
        ? {
            key: 'current',
            value: secondGraduation?.institution,
          }
        : ({} as InstitutionOption);

      return this.form.institution || institution;
    },
    fallbackInstitution(): InstitutionOption | null {
      return !this.isSearching ? { key: 'other', value: i18n.t('other') } : null;
    },
    name(): string {
      return this.$store.getters.user?.name || '';
    },
    evaluationStatus(): string {
      return this.$store.getters.evaluationStatus;
    },
  },
  methods: {
    async continueHandler(): Promise<void> {
      try {
        this.loading = true;
        const secondGraduation: EvaluationSecondGraduation = {
          courseName: this.form.course,
          year: this.form.graduationYear,
          institution: this.currentInstitution.value,
          hasAcceptedToS: this.hasAcceptedToS,
        };

        await this.$store.dispatch('UPDATE_SECOND_GRADUATION', { secondGraduation });
        this.$store.dispatch(AnalyticsActions.EVALUATION_SENT);
        await this.$store.dispatch('PULL_EVALUATION_STATUS');
        pipeline.next({ status: this.evaluationStatus });
      } catch (error) {
        this.errorHandler(error);
      } finally {
        this.loading = false;
      }
    },
    inputHandler(event: SecondGraduationInstitutionInfoFormEvent) {
      this.hasAcceptedToS = event.hasAcceptedToS;
      this.form = event;
    },
    searchHandler(input: string) {
      this.isSearching = true;

      clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(async () => {
        await this.$store.dispatch('PULL_AVAILABLE_INSTITUTIONS', { name: input });

        this.availableInstitutions = this.$store.getters.availableInstitutions.map(
          ({ id, name }: Institution) => ({
            key: String(id),
            value: name,
          }),
        );

        this.isSearching = false;
      }, 500);
    },
    errorHandler(error: any) {
      this.error = true;
      setTimeout(() => {
        this.error = false;
        this.loading = false;
      }, 5000);
      throw error;
    },
  },
});
